import { Component, Injectable, ViewEncapsulation, OnInit } from '@angular/core';
import { Router } from "@angular/router";
import { Subject, Subscription } from 'rxjs';
import { AuthService } from "../../services/auth/auth.service";
import { LookupService } from '../../services/lookups/lookup.service';
import { UserAgreementService } from '../../services/lookups/user-agreement.service';

@Injectable()

@Component({
  selector: 'app-dialog',
  templateUrl: './popup-dialog.component.html',
  styleUrls: ['./popup-dialog.component.css'],
  encapsulation: ViewEncapsulation.None,

})
export class PopUpDialogComponent implements OnInit {

  public dialogOpened: boolean = false;
  public termsOfServiceHTML;

  constructor(private router: Router, private authService: AuthService, private ls: LookupService, private uas: UserAgreementService) {}

  onUserAgreementLoaded: Subscription;

  ngOnInit() {

    this.uas.load();

    this.onUserAgreementLoaded = this.uas.userAgreementLoaded
      .subscribe(
        (response: any) => {
          this.termsOfServiceHTML = this.uas.getUserAgreement().userAgreementContent;
        });
  }

  public close(component) {
    this[component + 'Opened'] = false;
  }

  public open(component) {
    this[component + 'Opened'] = true;
  }

  public action(status) {
    console.log(`Dialog result: ${status}`);
    this.dialogOpened = false;
  }

  public onDialogDeny() {
    alert("You must accept Terms of Service if you want to continue to Portal.");
    this.dialogOpened = false;
  }

  public onDialogAccept() {
    this.dialogOpened = false;

    this.router.navigate(['/login']);
  }

}



// WEBPACK FOOTER //
// c:/Projects/YuDRIV/ServicesAPI/YuDriv-ServicesAPI/Enforcement/src/app/components/anon/popup-dialog.component.ts